module.exports = __webpack_public_path__ + "img/pasta-1.1c45750b.jpg";